import { useCallback, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { BookingPassport, PASSPORT_TYPE_LABEL } from "src/store/reducers/bookings";
import AddPassportBookingCanvas from "./AddPassportBookingCanvas";
import EditPassportBookingCanvas from "./EditPassportBookingCanvas";

interface ListBookingPassportsProps {
  bookingId: string;
  bookingPassportData: BookingPassport[];
  setDeletePassportId: React.Dispatch<React.SetStateAction<string | undefined>>;
}
function ListBookingPassports({
  bookingId,
  bookingPassportData,
  setDeletePassportId,
}: ListBookingPassportsProps) {
  const [editPassportId, setEditPassportId] = useState<number>();
  const [showPassportAddModal, setShowPassportAddModal] = useState(false);
  const [show, setShow] = useState(bookingPassportData.length > 0);
  const toggleShow = useCallback(() => {
    setShow((show) => !show);
  }, []);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-xxl-12">
            <div className="card h-auto">
              <div className="card-header">
                <h4
                  className="heading mb-0 link"
                  role="button"
                  onClick={toggleShow}
                >
                  {show ? (
                    <span className="btn-icon-start">
                      <i className="fa fa-minus color-info"></i>
                    </span>
                  ) : (
                    <span className="btn-icon-start">
                      <i className="fa fa-plus color-info"></i>
                    </span>
                  )}
                  Passports
                </h4>
                <Link
                  to={"#"}
                  className="btn btn-primary btn-sm"
                  data-bs-toggle="offcanvas"
                  onClick={() => setShowPassportAddModal(true)}
                >
                  + Add Passport
                </Link>
              </div>
              <div className={!show ? "card-body d-none" : "card-body"}>
                {bookingPassportData.length > 0 ? (
                  <div className="table-responsive active-projects">
                    <div
                      id="projects-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="projects-tbl"
                        className="table table-hover dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th>Full Name</th>
                            <th>Passport Number</th>
                            <th>Nationality</th>
                            <th>Date of Birth</th>
                            <th>Issue Date</th>
                            <th>Expiry Date</th>
                            <th>Type</th>
                            <th>Attachments</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bookingPassportData?.map((passportData, index) => (
                            <tr key={passportData.id}>
                              <td>{passportData.fullname}</td>
                              <td>{passportData.passport_number}</td>
                              <td>{passportData.nationality}</td>
                              <td>
                                {passportData.date_of_birth
                                  ? new Date(
                                      passportData.date_of_birth
                                    ).toLocaleDateString("en-IN")
                                  : ""}
                              </td>
                              <td>
                                {passportData.issue_date
                                  ? new Date(
                                      passportData.issue_date
                                    ).toLocaleDateString("en-IN")
                                  : ""}
                              </td>
                              <td>
                                {passportData.expiry_date
                                  ? new Date(
                                      passportData.expiry_date
                                    ).toLocaleDateString("en-IN")
                                  : ""}
                              </td>
                              <td>
                                {PASSPORT_TYPE_LABEL[passportData.passport_type]}
                              </td>
                              <td>
                                {passportData.attachments
                                  ? Object.keys(passportData.attachments).length
                                  : 0}
                              </td>
                              <td>
                                <NavLink
                                  className="btn btn-primary shadow btn-xs sharp me-1"
                                  onClick={() => setEditPassportId(index)}
                                  to={`#`}
                                  title="Edit"
                                >
                                  <i className={`fas fa-pen`} />
                                </NavLink>{" "}
                                <NavLink
                                  className="btn btn-danger shadow btn-xs sharp"
                                  onClick={() => {
                                    setDeletePassportId(passportData.id);
                                  }}
                                  to={`#`}
                                  title="Delete"
                                >
                                  <i className={`fas fa-x`} />
                                </NavLink>{" "}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    &nbsp;
                    <strong>Add passports for this booking </strong>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddPassportBookingCanvas
        Title={"Add Passport"}
        show={showPassportAddModal}
        bookingId={bookingId}
        setShow={setShowPassportAddModal}
      />
      <EditPassportBookingCanvas
        editId={
          typeof editPassportId !== "undefined"
            ? bookingPassportData?.[editPassportId]?.id
            : ""
        }
        Title={"Edit Passport"}
        bookingId={bookingId}
        data={
          typeof editPassportId !== "undefined"
            ? bookingPassportData?.[editPassportId]
            : undefined
        }
        hide={() => setEditPassportId(undefined)}
      />
    </>
  );
}

export default ListBookingPassports;
